var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDoodle4 = function SvgDoodle4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 52,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doodle4_svg__clip0_1338_891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.983 14.355c-4.157-1.443-8.964-.79-13.157.134-4.897 1.074-9.764 2.792-14.106 5.316-1.95 1.135-3.687 2.455-5.252 4.084-1.759 1.84-4.195 5.12-1.59 7.332.753.634 1.89.949 2.518-.032.694-1.088.083-2.654-.845-3.371-2.31-1.77-6.099-.985-8.646-.19-6.207 1.942-11.135 6.65-15.712 11.05-1.044 1.004-2.676-.551-1.62-1.562 4.938-4.746 10.303-9.77 17.043-11.748 3.177-.932 7.334-1.495 10.185.59 2.258 1.645 3.114 5.523.615 7.4-2.361 1.777-5.372-.028-6.45-2.386-1.608-3.493 1.162-6.92 3.516-9.264 4.044-4.025 9.684-6.432 15.049-8.123 5.778-1.829 13.03-3.498 18.979-1.418 1.357.471.85 2.663-.527 2.188z",
    fill: "#F05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "doodle4_svg__clip0_1338_891"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "scale(-1 1) rotate(-13.536 21.71 261.392)",
    d: "M0 0h52.73v39.79H0z"
  })))));
};
export default SvgDoodle4;